// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 19.43V19a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v.43m-3.23-11.7a2.5 2.5 0 1 1-3.54 3.54 2.5 2.5 0 0 1 3.54-3.54Zm4.6-2.1A9 9 0 1 1 5.63 18.37 9 9 0 0 1 18.36 5.64Z\" stroke=\"#98A1B3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expert-tip {
  box-sizing: border-box;
  display: block;
  padding: 64px 16px 8px;
  margin: 1em 0;
  background: #f7f9fc;
  border-radius: 6px;
  position: relative;
  color: #1e2532;
}

.expert-tip:before {
  content: 'Expert Tip';
  position: absolute;
  font-family: sans-serif;
  display: block;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  top: 20px;
  left: 16px;
  right: 16px;
  padding-bottom: 20px;
  color: #505762;
  border-bottom: 1px solid #e7eaf4;
}

.expert-tip.expert-tip_with-author {
  position: relative;
  padding-top: 78px;
}

.expert-tip.expert-tip_with-author:before {
  display: none;
}

.expert-tip__author-name,
.expert-tip__author-title {
  font-family: sans-serif;
  position: absolute;
  left: 16px;
  right: 16px;
  outline: none !important;
  padding-left: 44px;
  font-size: 12px;
  line-height: 16px;
  min-height: 16px;
  box-sizing: content-box;
}

.expert-tip__author-name {
  color: #0f141f;
}

.expert-tip__author-name:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 38px 38px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
}

.expert-tip__author-title {
  color: #656e83;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-bottom: 20px;
  border-bottom: 1px solid #e7eaf4;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/expert-tip/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAA4Y;EAC5Y,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;AAClC","sourcesContent":[".expert-tip {\n  box-sizing: border-box;\n  display: block;\n  padding: 64px 16px 8px;\n  margin: 1em 0;\n  background: #f7f9fc;\n  border-radius: 6px;\n  position: relative;\n  color: #1e2532;\n}\n\n.expert-tip:before {\n  content: 'Expert Tip';\n  position: absolute;\n  font-family: sans-serif;\n  display: block;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  top: 20px;\n  left: 16px;\n  right: 16px;\n  padding-bottom: 20px;\n  color: #505762;\n  border-bottom: 1px solid #e7eaf4;\n}\n\n.expert-tip.expert-tip_with-author {\n  position: relative;\n  padding-top: 78px;\n}\n\n.expert-tip.expert-tip_with-author:before {\n  display: none;\n}\n\n.expert-tip__author-name,\n.expert-tip__author-title {\n  font-family: sans-serif;\n  position: absolute;\n  left: 16px;\n  right: 16px;\n  outline: none !important;\n  padding-left: 44px;\n  font-size: 12px;\n  line-height: 16px;\n  min-height: 16px;\n  box-sizing: content-box;\n}\n\n.expert-tip__author-name {\n  color: #0f141f;\n}\n\n.expert-tip__author-name:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 32px;\n  height: 32px;\n  background-image: url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 19.43V19a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v.43m-3.23-11.7a2.5 2.5 0 1 1-3.54 3.54 2.5 2.5 0 0 1 3.54-3.54Zm4.6-2.1A9 9 0 1 1 5.63 18.37 9 9 0 0 1 18.36 5.64Z\" stroke=\"#98A1B3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>');\n  background-size: 38px 38px;\n  background-repeat: no-repeat;\n  background-position: center;\n  border-radius: 50%;\n}\n\n.expert-tip__author-title {\n  color: #656e83;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e7eaf4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
